import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api";
import type { MaterialVariance, MaterialTrend } from "@shared/types";

export function useMaterialVariance(
  from: string,
  to: string,
  product?: string
) {
  return useQuery({
    queryKey: ["materials", "variance", from, to, product],
    queryFn: () =>
      apiFetch<MaterialVariance[]>("/api/materials/variance", {
        from,
        to,
        product,
      }),
  });
}

export function useMaterialTrend(
  material: string,
  from: string,
  to: string,
  product?: string
) {
  return useQuery({
    queryKey: ["materials", "trend", material, from, to, product],
    queryFn: () =>
      apiFetch<MaterialTrend[]>("/api/materials/trend", {
        material,
        from,
        to,
        product,
      }),
    enabled: !!material,
  });
}
